import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAuth} from '../hooks/useAuth';
import {useNotifyHook} from '../hooks/useNotify';

const ProfilePage = () => {
    const {user, isAuthenticated, logout} = useAuth();
    const navigate = useNavigate();
    const notify = useNotifyHook();

    useEffect(() => { // Redirect to home if not logged in
        if (!isAuthenticated()) {
            notify.error('Please login to view profile');
            navigate('/');
        }
    }, [isAuthenticated, navigate, notify]);

    const handleLogout = () => {
        logout();
        notify.success('Logged out successfully');
        window.location.href = '/';
    };

    if (!isAuthenticated()) {
        return null;
    }

    const handleMyBookings = () => {
        navigate('/my-bookings');
    };

    return (
        <div className="min-h-screen bg-gray-50 py-8">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Header */}
                <div className="mb-8">
                    <h1 className="text-3xl font-bold text-gray-900">My Profile</h1>
                    <p className="text-gray-600 mt-2">Manage your account information</p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                    {/* Left Column - Profile Info */}
                    <div className="lg:col-span-2 space-y-6">
                        {/* Personal Information Card */}
                        <div className="bg-white rounded-lg shadow-md p-6">
                            <div className="flex justify-between items-center mb-6">
                                <h2 className="text-xl font-semibold text-gray-800">Personal Information</h2>
                                    {/* <button className="text-blue-600 hover:text-blue-800 font-medium text-sm">
                                        Edit
                                    </button> */}
                            </div>

                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-500 mb-1">
                                        Full Name
                                    </label>
                                    <p className="text-gray-900 font-medium">
                                        {
                                        user ?. name || 'Not provided'
                                    } </p>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-500 mb-1">
                                        Phone Number
                                    </label>
                                    <p className="text-gray-900 font-medium">
                                        +91 {
                                        user ?. phone || 'Not provided'
                                    } </p>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-500 mb-1">
                                        Email Address
                                    </label>
                                    <p className="text-gray-900 font-medium">
                                        {
                                        user ?. email || 'Not provided'
                                    } </p>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-500 mb-1">
                                        Account Created
                                    </label>
                                    <p className="text-gray-900 font-medium">
                                        {
                                        user ?. createdAt ? new Date(user.createdAt).toLocaleDateString() : 'N/A'
                                    } </p>
                                </div>
                            </div>
                        </div>

                        {/* Account Settings Card */}
                        {/* <div className="bg-white rounded-lg shadow-md p-6">
                            <h2 className="text-xl font-semibold text-gray-800 mb-6">Account Settings</h2>

                            <div className="space-y-4">

                                <div className="flex items-center justify-between py-3">
                                    <div>
                                        <h3 className="font-medium text-gray-900">Delete Account</h3>
                                        <p className="text-sm text-gray-500">Permanently delete your account</p>
                                    </div>
                                    <button className="text-red-600 hover:text-red-800 font-medium text-sm">
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </div> */}
                    </div>

                    {/* Right Column - Profile Sidebar */}
                    <div className="space-y-6">
                        {/* Profile Card */}
                        <div className="bg-white rounded-lg shadow-md p-6">
                            <div className="flex flex-col items-center">
                                {/* Profile Avatar */}
                                <div className="w-32 h-32 rounded-full bg-blue-100 flex items-center justify-center mb-4">
                                    {
                                    user ?. avatar ? (
                                        <img src={
                                                user.avatar
                                            }
                                            alt="Profile"
                                            className="w-full h-full rounded-full object-cover"/>
                                    ) : (
                                        <span className="text-4xl font-bold text-blue-600">
                                            {
                                            user ?. name ?. charAt(0) || user ?. phone ?. charAt(0) || 'U'
                                        } </span>
                                    )
                                } </div>

                                <h2 className="text-xl font-bold text-gray-900 mb-1">
                                    {
                                    user ?. name || 'User'
                                } </h2>
                                <p className="text-gray-600 mb-6">+91 {
                                    user ?. phone
                                }</p>


                            </div>
                        </div>

                        {/* Quick Actions Card */}
                        <div className="bg-white rounded-lg shadow-md p-6">
                            <h3 className="font-semibold text-gray-800 mb-4">Quick Actions</h3>

                            <div className="space-y-3">
                                <button onClick={handleMyBookings} className="w-full text-left p-3 rounded-lg hover:bg-gray-50 border border-gray-200">
                                    <span className="font-medium text-gray-900">My Bookings</span>
                                    <p className="text-sm text-gray-500">View booking history</p>
                                </button>


                            </div>
                        </div>

                        {/* Logout Button */}
                        <button onClick={handleLogout}
                            className="w-full py-3 px-4 bg-red-600 text-white rounded-md hover:bg-red-700 transition font-medium flex items-center justify-center">
                            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
                            </svg>
                            Logout
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfilePage;
